import React, { useState, useEffect } from "react";
import Modal from "../modal";

function FindImportModal({ showB, handleshow, realizarConsulta }) 
{
  const [shows, setShow] = useState(showB);
  const [nombreusr, setNombreUsr] = useState("");
  const [numeronit, setNumeronit] = useState("");
  const [estado, setEstado] = useState("");
  //--------------------------------------------------------------------------------------------------------------------
  const handleCancel = async () => {
    handleshow(false);
  };
  //--------------------------------------------------------------------------------------------------------------------
  const handleAceptar = () => 
    {
      realizarConsulta(numeronit, nombreusr);
      setShow(false);
      handleshow(false);
    };
  //--------------------------------------------------------------------------------------------------------------------
  useEffect(() => 
    {
     
     }, []);
    
  return (
    <>
      <Modal isOpen={showB} onClose={()=>handleshow(false)} title={'Buscar'}>
        <div className="flex lg:w-[25rem]">
          <form noValidate className="flex flex-col w-full">
            <div className="flex flex-col w-full h-full ">
              <div className="w-full">
                  <label>Documento</label>
                  <input type="text" name='searchid' value={numeronit || ""} placeholder="Documento del usuario..." 
                      onChange={(e)=> setNumeronit(e.target.value)}
                      autoComplete="off" 
                  />
              </div>
              <div className="w-full mt-4">
                  <label>Nombre</label>
                  <input type="text" name='searchid' value={nombreusr || ""} placeholder="Nombre del usuario..." 
                      onChange={(e)=> setNombreUsr(e.target.value.toUpperCase())}
                      autoComplete="off" 
                  />
              </div>
             
            </div>
            <div className="flex w-full gap-4 mt-6 justify-end">
              <button name="Aceptar" className="btnprimary" onClick={handleAceptar}  type="button">Aceptar</button>
              <button name="Cancelar" className="" onClick={handleCancel} type="button">Cancelar</button>
            </div> 
          </form>   
        </div>                                 
      </Modal>
    </>
  );
}
export default FindImportModal;
